module.exports = __webpack_public_path__ + "img/code.24f85998.png";